// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"9e19bf56","167":"66ae5624","268":"8d320b06","359":"8e00a12e","432":"4c8ba234","453":"b1a579c5","612":"e7a4e556","739":"09dace20","992":"80d43c33"}[chunkId] + ".chunk.js";
};